<template>
  <div class="d-number-item">
    <div style="width: 100%">
      <div class="d-number-item-num">
        {{ numberText }}
        <span class="d-number-item-unit">
          {{ numUnit }}
        </span>
      </div>
      <div class="d-number-item-title">{{ numTitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataNumItem',
  data () {
    return {
      numberText: this.num, // 数字
      numTitle: this.title, // 标题
      numUnit: this.unit // 计量单位
    }
  },
  props: {
    'num': {
      type: Number,
      default: 0
    },
    'title': {
      type: String,
      default: ''
    },
    'unit': {
      type: String,
      default: ''
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style scoped>
.d-number-item {
  width: 16%;
  margin: 5px 0 15px 0;
  padding: 5px;
  border: 1px solid #3a8ee6;
  color: #ffffff;
  border-radius: 5px;
}
.d-number-item-num {
  width: 100%;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  font-size: 16px;
}
.d-number-item-title {
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  background-image: linear-gradient(to right, #ffffff, #449dff);
  -webkit-background-clip: text;
  color: transparent;
}
.d-number-item-unit {
  color: #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Data_num_item.vue